'use client';
import { useEffect } from 'react';
import { ContentRenderer } from '@portal/content-renderer';

import FilterByInput from 'src/components/FilterByInput';
import FilterByLetter from 'src/components/FilterByLetter';
import MyTestsSummary from 'src/components/MyTestsSummary';
import Pagination from 'src/components/Pagination';
import TestCategories from './TestCategories';
import TestsList from './TestsList';
import FinishAppointmentButton from './FinishAppointmentButton';

type Props = {
    title: string;
    tests: any[];
    category?: any;
    categories?: any[];
    pageUrl?: string;
    total?: number;
    page?: number;
    pageParams?: any;
    withFilters?: boolean;
};

export default function TestsPanels({
    title,
    tests,
    category = null,
    categories = [],
    pageUrl = '',
    total = 0,
    page = 1,
    pageParams = {},
    withFilters = false,
}: Props) {
    useEffect(() => {
        if (pageParams.l || pageParams.page || pageParams.filter) {
            document.getElementById('tests-list')?.scrollIntoView();
        }
    }, [pageParams]);

    return (
        <div className="text-dark-green container mx-auto flex-row lg:flex">
            <div className="basis-2/3 py-10">
                {withFilters && (
                    <div className="gap-8 px-4 md:flex">
                        <div className="mb-4 md:mb-0 md:w-1/3">
                            <TestCategories categories={categories} selected={category?.slug} />
                        </div>
                        <div className="flex-1">
                            <FilterByInput id="filter" pathname={pageUrl} placeholder="Sau caută după denumire" />
                        </div>
                    </div>
                )}

                {withFilters && <FilterByLetter className="my-4 md:mx-4" />}

                <div className="px-4" id="tests-list">
                    <TestsList title={title || undefined} items={tests} />

                    <Pagination url={pageUrl} total={total} page={page} params={pageParams} className="my-4" />

                    {category && (
                        <div className="description markuclassNameop-5">
                            <ContentRenderer content={category.content} />
                        </div>
                    )}
                </div>
            </div>
            <div className="hidden basis-1/3 px-4 py-10 lg:block">
                <div className="top-nav-md-height sticky bg-white p-8">
                    <MyTestsSummary withLink={true} />
                </div>
            </div>
            <FinishAppointmentButton />
        </div>
    );
}
